import { GenericObject } from "src/api/flowTypes";
import { NodeExecutionResult } from "src/api/testRuns/testRunQueries";
import { NodeExecutionMetadata } from "src/api/types";
import { logger } from "src/utils/logger";

// Non-dict payloads normalize to {} to match the live node-executions API.
const isPlainObject = (value: unknown): value is GenericObject =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const parseJsonObject = (value: unknown, field: string): GenericObject => {
  if (typeof value === "string") {
    try {
      const parsed: unknown = JSON.parse(value);
      return isPlainObject(parsed) ? parsed : {};
    } catch (error) {
      logger.error(
        error,
        `Failed to parse eager node-execution field "${field}"`,
      );
      return {};
    }
  }
  return isPlainObject(value) ? value : {};
};

// node_id is the UNLOAD partition key (in the path, not the row), so the caller supplies it.
export const ndjsonRowToNodeExecutionResult = (
  row: Record<string, unknown>,
  nodeId: string,
): NodeExecutionResult => ({
  data: parseJsonObject(row.data, "data"),
  decision_metadata: {
    id: String(row.decision_id ?? ""),
    status_code: String(row.status_code ?? ""),
    error: (row.error ?? null) as string | null,
    source_entry_id: (row.source_entry_id ?? null) as string | null,
  },
  execution_metadata: parseJsonObject(
    row.execution_metadata,
    "execution_metadata",
  ) as NodeExecutionMetadata,
  tracing_data: parseJsonObject(row.tracing_data, "tracing_data") as Record<
    string,
    GenericObject
  >,
  node_id: nodeId,
  node_name: String(row.node_name ?? ""),
});
